import { Component, OnInit, Input } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';

/**
 * Services 
 */
import { GetContactInfoService } from "../../../services/receipts/getContactInfo/get-contact-info.service"
import { GetselectedContactInfoService } from "../../../services/receipts/getselectedContactInfo/getselected-contact-info.service"
import { GetOfferingTypeService } from "../../../services/receipts/getOfferingType/get-offering-type.service"
import { GetEventService } from "../../../services/receipts/getEvent/get-event.service"
import { GetEventPaymentService } from "../../../services/receipts/getEventPayment/get-event-payment.service"
import { GetBankService } from "../../../services/receipts/getBank/get-bank.service"
import { GetDraweeBankService } from "../../../services/receipts/getDraweeBank/get-drawee-bank.service"
import { GetAmbassadorInfoService } from "../../../services/receipts/getAmbassadorInfo/get-ambassador-info.service"
import { KeyMapService } from "../../../services/key-map/key-map.service"
import { AddNewReceiptService } from "../../../services/receipts/addNewReceipt/add-new-receipt.service"
import { AppComponent } from "../../../app.component";

declare var $: any;
@Component({
  selector: 'app-addreceipts',
  templateUrl: './addreceipts.component.html',
  styleUrls: ['./addreceipts.component.less']
})
export class AddreceiptsComponent implements OnInit {
  @Input() lastvisited: Date;

  public offeringBox = [0]

  public addReceiptData = {
    contact: "",
    email: "",
    phoneNumber: "",
    received: "",
    receivedViaBank: "",
    totalAmount: 0
  }

  public ambassadorData: any
  public offeringTypeData: any
  public event: any
  public eventPayment: any
  public bank: any
  public bankDrawee: any
  public isView: Boolean = false
  public viewDetails
  public submitLoading: Boolean = false

  public received = {
    asCash: false,
    viaBank: false,
    viaPaymentGateWay: false
  }

  public receivedViaBank = {
    bankTransfer: false,
    cheque: false,
    bankDeposit: false,
    DD: false
  }

  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    // locale: frLocale,
    // minDate: new Date(Date.now()), // Minimal selectable date
    // maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  /**
   * contact search keys
   */
  keyword = 'name'
  contactInfoData: any = []

  constructor(
    private GetContactInfoService: GetContactInfoService,
    private GetselectedContactInfoService: GetselectedContactInfoService,
    private GetOfferingTypeService: GetOfferingTypeService,
    private GetEventService: GetEventService,
    private GetEventPaymentService: GetEventPaymentService,
    private GetBankService: GetBankService,
    private GetDraweeBankService: GetDraweeBankService,
    private GetAmbassadorInfoService: GetAmbassadorInfoService,
    private KeyMapService: KeyMapService,
    private AddNewReceiptService: AddNewReceiptService,
    private AppComponent:AppComponent
  ) {
  }

  async ngOnInit() {
    this.AppComponent.hideAllHeaderSideNavFooter()
    await this.GetAmbassadorInfo()
  }

  async addNewReceipt(Data) {
    this.submitLoading = true;
    var offering_type = []
    Data.contact = Data.contact.id
    if (Data.received == "asCash") {
      Data.received = 1
      offering_type = await this.keyMapForDynamicFormField(Data)
    } else if (Data.received == "viaBank") {
      Data.received = 2
      offering_type = await this.keyMapForDynamicFormField(Data)
    } else if (Data.received == "viaPaymentGateWay") {
      Data.received = 3
      offering_type = await this.keyMapForDynamicFormField(Data)
    }

    for (const key in this.offeringBox) {
      if (this.offeringBox.hasOwnProperty(key)) {
        const element = this.offeringBox[key];
        delete Data[`offeringType_${element}`]
        delete Data[`event_${element}`]
        delete Data[`eventPayment_${element}`]
        delete Data[`amount_${element}`]
      }
    }
    let ot = { offering_type: offering_type }
    let data = { ...Data, ...ot }
    let finalData = await this.KeyMapService.KeyMapping(data, "addReceipt")
    console.log(finalData)
    let result = await this.AddNewReceiptService.addReceipt(finalData)
    console.log(result)
  }

  keyMapForDynamicFormField(data) {
    let res = []
    for (const key in this.offeringBox) {
      if (this.offeringBox.hasOwnProperty(key)) {
        const element = this.offeringBox[key];
        if (data[`offeringType_${element}`] != "") {
          res.push({ offering_type: data[`offeringType_${element}`], offering_amt: data[`amount_${element}`] })
        } else if (data[`event_${element}`] != "") {
          res.push({ offering_type: data[`eventPayment_${element}`], event_id: data[`event_${element}`], offering_amt: data[`amount_${element}`] })
        }
      }
    }
    return res
  }

  disableEventEventPaymentSelection(val, key) {
    if (key == 1) {
      $(`[data-id="event_${val}"]`).prop('disabled', true);
      $(`[data-id="eventPayment_${val}"]`).prop('disabled', true);
    } else if (key == 2) {
      $(`[data-id="offeringBox_${val}"]`).prop('disabled', true);
    }
  }

  async calAmount() {
    this.sumAmount();
  }

  sumAmount() {
    var sum = 0;
    $(".price").each(function () {
      //add only if the value is number 
      if (!isNaN(this.value) && this.value.length != 0) {
        sum += parseFloat(this.value);
      }
    });
    this.addReceiptData.totalAmount = sum
  }


  async getOfferingType() {
    let data = await this.GetOfferingTypeService.GetOfferingType()
    this.offeringTypeData = data.data
    setTimeout(function () {
      $(".offeringType_0").selectpicker('refresh');
    }, 100)
  }
  async getEvent() {
    let data = await this.GetEventService.GetEvent()
    this.event = data.data
    setTimeout(function () {
      $(`.event_0`).selectpicker('refresh');
    }, 100)
  }
  async getEventPayment() {
    let data = await this.GetEventPaymentService.GetEventPayment()
    this.eventPayment = data.data
    setTimeout(function () {
      $(`.eventPayment_0`).selectpicker('refresh');
    }, 100)
  }
  async getBank() {
    let data = await this.GetBankService.GetBank()
    this.bank = data.data
    setTimeout(function () {
      $(`.bank`).selectpicker('refresh');
    }, 100)
  }
  async getBankDrawee() {
    let data = await this.GetDraweeBankService.GetBankDrawee()
    this.bankDrawee = data.data
    setTimeout(function () {
      $(`.bankDrawee`).selectpicker('refresh');
    }, 100)
  }

  async selectContact(item) {
    let selectedContactInfo = await this.GetselectedContactInfoService.GetSelectedContactInfo(item.id)
    let view = selectedContactInfo.data[0]
    this.addReceiptData.email = item.email
    this.addReceiptData.phoneNumber = view.PRIMARY_MOBILE_NO
    this.isView = true
    this.viewDetails = view.TITLE_NAME + " " + view.ADDRESS_LINE1 + " " + view.ADDRESS_LINE2 + " " + view.ADDRESS_LINE3 + " " + view.CITY + " " + view.PINCODE + " " + view.STATE_NAME + " " + view.COUNTRY_NAME
  }

  async onChangeContactSearch(val: string) {
    this.contactInfoData = []
    let getContactData = await this.GetContactInfoService.GetContactInfo(val)
    if (getContactData.data.length != 0) {
      getContactData.data.forEach(element => {
        this.contactInfoData.push({ id: element.PARTNER_ID, name: `${element.PARTNER_ID} - ${element.FULL_NAME} - ${element.PRIMARY_MOBILE_NO} - ${element.EMAIL_ID}`, email: element.EMAIL_ID })
      });
    }
  }
  async onFocusedContactSearch(e) {
    let getContactData = await this.GetContactInfoService.GetContactInfo("")
    if (getContactData.data.length != 0) {
      getContactData.data.forEach(element => {
        this.contactInfoData.push({ id: element.PARTNER_ID, name: `${element.PARTNER_ID} - ${element.FULL_NAME} - ${element.PRIMARY_MOBILE_NO} - ${element.EMAIL_ID}`, email: element.EMAIL_ID })
      });
    }
  }

  async GetAmbassadorInfo() {
    let GetAmbassadorData = await this.GetAmbassadorInfoService.getAmbassadorInf()
    this.ambassadorData = GetAmbassadorData.data
    setTimeout(function () {
      $(`.ambassador`).selectpicker('refresh');
    }, 100)
  }


  onPaymentReceived(e, value) {
    this.addReceiptData.received = value
    if (value == 'asCash') {
      this.received.asCash = true
      this.received.viaBank = false
      this.received.viaPaymentGateWay = false
      this.getOfferingType()
      this.getEvent()
      this.getEventPayment()
      setTimeout(function () {
        $(".offeringType_0").selectpicker('refresh');
        $(".event_0").selectpicker('refresh');
        $(`.eventPayment_0`).selectpicker('refresh');
      }, 100)
    } else if (value == 'viaBank') {
      this.received.asCash = false
      this.received.viaBank = true
      this.received.viaPaymentGateWay = false
      this.getOfferingType()
      this.getEvent()
      this.getEventPayment()
      this.getBank()
      setTimeout(function () {
        $(".offeringType_0").selectpicker('refresh');
        $(".event_0").selectpicker('refresh');
        $(`.eventPayment_0`).selectpicker('refresh');
      }, 100)
    } else if (value == 'viaPaymentGateWay') {
      this.received.asCash = false
      this.received.viaBank = false
      this.received.viaPaymentGateWay = true
      this.getOfferingType()
      this.getEvent()
      this.getEventPayment()
      setTimeout(function () {
        $(".offeringType_0").selectpicker('refresh');
        $(".event_0").selectpicker('refresh');
        $(`.eventPayment_0`).selectpicker('refresh');
      }, 100)
    }
  }

  onPaymentViaBankReceived(e, value) {
    this.addReceiptData.receivedViaBank = value
    if (value == 'bankTransfer') {
      this.receivedViaBank.bankTransfer = true
      this.receivedViaBank.cheque = false
      this.receivedViaBank.bankDeposit = false
      this.receivedViaBank.DD = false
    } else if (value == 'cheque') {
      this.getBankDrawee()
      setTimeout(function () {
        $(`.bankDrawee`).selectpicker('refresh');
      }, 100)
      this.receivedViaBank.bankTransfer = false
      this.receivedViaBank.cheque = true
      this.receivedViaBank.bankDeposit = false
      this.receivedViaBank.DD = false
    } else if (value == 'bankDeposit') {
      this.receivedViaBank.bankTransfer = false
      this.receivedViaBank.cheque = false
      this.receivedViaBank.bankDeposit = true
      this.receivedViaBank.DD = false
    } else if (value == 'dd') {
      this.getBankDrawee()
      setTimeout(function () {
        $(`.bankDrawee`).selectpicker('refresh');
      }, 100)
      this.receivedViaBank.bankTransfer = false
      this.receivedViaBank.cheque = false
      this.receivedViaBank.bankDeposit = false
      this.receivedViaBank.DD = true
    }
  }

  async switchToGetNullForReceived(key) {
    switch (key) {
      case "asCash":
        return {
          /**
           * via Bank
           */
          bank: null,
          receivedViaBank: null,
          refNumber: null,
          transactionDate: null,
          checkDDNumber: null,
          checkDDDate: null,
          bankDrawee: null,
          deposited: null,
          depositedLocation: null,

          /**
           * via Payment Gateway
           */
          paymentGateway: null,
          gatewayTransactionDate: null,

        }
      case "viaBank":
        return {
          /**
           * as Case
           */
          medium: null,

          /**
           * via Payment Gateway
           */
          paymentGateway: null,
          gatewayTransactionDate: null,

        }
      case "viaPaymentGateWay":
        return {
          /**
           * as Case
           */
          medium: null,

          /**
         * via Bank
         */
          bank: null,
          receivedViaBank: null,
          refNumber: null,
          transactionDate: null,
          checkDDNumber: null,
          checkDDDate: null,
          bankDrawee: null,
          deposited: null,
          depositedLocation: null,

        }
    }
  }

  async AddNewOfferingBox(id) {
    this.offeringBox.push(id)
    setTimeout(function () {
      $(`.offeringType_${id}`).selectpicker('refresh');
      $(`.event_${id}`).selectpicker('refresh');
      $(`.eventPayment_${id}`).selectpicker('refresh');
    }, 100)
  }

  async removeOfferingBox(id) {
    let val = $(`#price_${id}`).val()
    this.addReceiptData.totalAmount = this.addReceiptData.totalAmount - val
    if (this.offeringBox.length != 1) {
      const index = this.offeringBox.indexOf(id);
      if (index > -1) {
        this.offeringBox.splice(index, 1);
      }
    }
  }


  /**
   * Email Validation
   */
  formEmailValidation(elementValue) {
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailPattern.test(elementValue)) {
      $("#email").removeClass("is-invalid")
    } else {
      if ($("#email").hasClass("is-invalid")) {
        $("#email").removeClass("is-invalid")
      } else {
        $("#email").addClass("is-invalid")
      }
    }
  }
  emailValidation(elementValue) {
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(elementValue)
  }
  }
